import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const AirlineSeat = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M5.66667 4.00016C5.3 4.00016 4.98611 3.86961 4.725 3.6085C4.46389 3.34738 4.33333 3.0335 4.33333 2.66683C4.33333 2.30016 4.46389 1.98627 4.725 1.72516C4.98611 1.46405 5.3 1.3335 5.66667 1.3335C6.03333 1.3335 6.34722 1.46405 6.60833 1.72516C6.86944 1.98627 7 2.30016 7 2.66683C7 3.0335 6.86944 3.34738 6.60833 3.6085C6.34722 3.86961 6.03333 4.00016 5.66667 4.00016ZM9.33333 13.3335H5.03333C4.66667 13.3335 4.33056 13.2029 4.025 12.9418C3.71944 12.6807 3.52778 12.3668 3.45 12.0002L2 4.66683H3.36667L4.83333 12.0002H9.33333V13.3335ZM13 14.6668L11.0667 11.3335H6.43333C6.11111 11.3335 5.83056 11.2363 5.59167 11.0418C5.35278 10.8474 5.2 10.5891 5.13333 10.2668L4.4 6.70016C4.27778 6.16683 4.40278 5.69461 4.775 5.2835C5.14722 4.87238 5.6 4.66683 6.13333 4.66683C6.52222 4.66683 6.875 4.7835 7.19167 5.01683C7.50833 5.25016 7.71111 5.56683 7.8 5.96683L8.53333 9.3335H10.7C10.9333 9.3335 11.15 9.39461 11.35 9.51683C11.55 9.63905 11.7111 9.80016 11.8333 10.0002L14.1667 14.0002L13 14.6668Z",
    fill: color
  }));
};
export default AirlineSeat;